import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202102220013', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'productCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202101260018', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'productName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220001', { defaultText: '企业前缀' }),
                align: 'center',
                prop: 'tenantCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220025', { defaultText: '更新数据' }),
                type: 'hint',
                align: 'center',
                prop: 'jsonBody',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220026', { defaultText: '操作类型' }),
                align: 'center',
                prop: 'operateType',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220023', { defaultText: '操作人' }),
                align: 'center',
                prop: 'createUserName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220013', { defaultText: '操作时间' }),
                align: 'center',
                prop: 'createTime',
                filter: true,
                require: true,
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
